import { Component } from '@angular/core';
import { AuthenticationService } from '@services/authentication/authentication.service';
import { FilesService } from '@services/files/files.service';
import { ToastService } from '@services/toast/toast.service';

@Component({
  selector: 'app-toasts',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss']
})
export class ToastsComponent {
  public notifications: any = {}
  public timeout = 3000;

  constructor(
    public toastService: ToastService,
    public filesService: FilesService,
    private authenticationService: AuthenticationService
  ) {
    this.authenticationService.authChanged$.subscribe(result => {
      if (result) {
        window.setTimeout(() => {
          this.loadNotifications()
        }, this.timeout)
      }
    })
  }

  async loadNotifications() {
    this.notifications = await this.filesService.getNotifications()

    if (!this.notifications) return;

    const today = new Date().getTime();
    
    for (const notificaton of this.notifications) {
      const from = new Date(notificaton.from).getTime()
      const to = new Date(notificaton.to).getTime()

      if (from <= today && to >= today) {
        const id = this.getToastId(notificaton.message);
        let isHidden = localStorage.getItem(`notification_${id}`) == 'hide';
        if (isHidden) return;

        this.toastService.clear('all');
        this.toastService.note(notificaton.message, false, 'bottomright')
      }
    }
  }

  clear(position: string = 'topcenter') {
    this.toastService.clear(position);
    // this.toastService.askToHidePrevious("Nicht mehr anzeigen?");
  }

  hidePrevious() {
    const content = this.toastService.history[this.toastService.history.length - 2];
    const id = this.getToastId(content);
    localStorage.setItem(`notification_${id}`, 'hide');
    this.toastService.clear();
  }

  getToastId(content) {
    return content.trim().toLowerCase().replace(/ /g, '').substring(0, 24);
  }
}